import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { feelJoinUseCase$ } from '../../application/use-cases/feel-subscription.use-cases';
import { FeelSubscriptionApiRepository } from '../api/feel-subscription.api.repository';

import { StoreAndLanguage } from '@core/domain/state/core.state';

@Injectable()
export class FeelSubscriptionPublicPorts {
    constructor(
        private readonly feelSubscriptionApiRepository: FeelSubscriptionApiRepository,
    ) {}

    public feelJoin$(storeAndLanguage: StoreAndLanguage): Observable<void> {
        return feelJoinUseCase$(storeAndLanguage, this.feelSubscriptionApiRepository);
    }
}
